import { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'

export const CheckoutRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<RedirectToNewCheckout />} path="*" />
    </Routes>
  )
}

const RedirectToNewCheckout = () => {
  useEffect(() => {
    const path = `${window.location.protocol}//${window.location.host}/free${window.location.pathname}`
    console.log(path)
    window.location.href = path
  }, [])
  return <></>
}
